import { render, staticRenderFns } from "./Genres.vue?vue&type=template&id=fbb11534&scoped=true&"
import script from "./Genres.vue?vue&type=script&lang=js&"
export * from "./Genres.vue?vue&type=script&lang=js&"
import style0 from "./Genres.vue?vue&type=style&index=0&id=fbb11534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb11534",
  null
  
)

export default component.exports